<template>
  <button
    aria-haspopup="dialog"
    aria-label="View Custom Colors"
    class="link-med"
    :class="{'divider padding-right-xs margin-right-xs' : orderSwatches}"
    @click.stop="openCustomColorsDrawer"
  >
    View Custom Colors
  </button>
</template>

<script setup>
import { defineAsyncComponent, markRaw } from 'vue';
import { useFeatureEligibility } from '@modules/featureControl';
import { useSlideout } from '@composables/utils/useSlideout';

const { orderSwatches } = useFeatureEligibility();
const { showSlideout } = useSlideout();

const openCustomColorsDrawer = () => {
  showSlideout({
    id: 'View Custom Colors',
    title: 'Custom Colors',
    component: markRaw(defineAsyncComponent(() => import(/* webpackChunkName: "ViewCustomColorsInfo" */ '@components/slideoutContent/viewCustomColors/ViewCustomColorsInfo'))),
  });
};
</script>

<style lang="scss" scoped>
.divider {
    border-right: 1px solid $gray-3-color;
    border-radius: unset;
}
</style>
